import axios from "axios";
import NetworkUtils from "@/NetworkUtils";
import store from "../../store";
const authorize =  `Bearer ${store.getters.getToken}`;
const config = {
    headers: { Authorization: authorize }
};

export default {

    loadUGSSetting : async function() {
        let data = await axios.get(NetworkUtils.HOST + '/environment-config', config);
        if (data.data.length > 0) {
            data = data.data[0].list;
            return data;
        } else {
            return  null;
        }
    },
}